import React from 'react';
import { Platform } from 'react-native';
import { t } from '~/utils/i18n';
import { Container, Title, Body } from './style';

export default function WebDeprecationBanner(): JSX.Element | null {
  // Web-only: renders nothing on iOS/Android - no layout, no accessibility footprint.
  if (Platform.OS !== 'web') {
    return null;
  }

  return (
    <Container>
      <Title>{t('webDeprecationBanner.title')}</Title>
      <Body>{t('webDeprecationBanner.body')}</Body>
    </Container>
  );
}
